/** Enlace `tel:` de un telefono escrito con espacios (`+56 2 2698 4785`). */
export function enlaceTelefono(telefono: string): string {
  return `tel:${telefono.replace(/\s/g, '')}`;
}
